/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  process:{
    done:0,
    processing:0,
    delivering:0,
    outofstock:0,
  },
  withdraw: {
    total:0,
    success:0,
    all:0,
  },
  deposit:{
    bonus:0,
    bonustotal:0,
  },
  deposit30:[{
    name: 'ฝาก',
    data: []
  }],
  withdraw30:[{
    name: 'ถอน',
    data: []
  }],
  active30:[{
    name: 'ผู้ใช้',
    data: []
  }],
  usersactive:{
    active:0,
    total:0,
  },
  users:[],
  krungsri:{
    total:0,
    success:0,
    all:0,
  }
}
